import {ListPaginationEntity} from "@dropDesk/domain/entities/common/list_pagination.entity";
import {TicketMessageEntity} from "@dropDesk/domain/entities/ticket/message/ticket_message.entity";
import {ChatTicketHeaderEntity} from "@dropDesk/domain/entities/chat/chat_ticket_header.entity";

export class ListPaginationChatMessagesEntity extends ListPaginationEntity<TicketMessageEntity> {
    ticket!: ChatTicketHeaderEntity;
    previousTicket?: ChatTicketHeaderEntity | null;
    previousTicketCached!: boolean;
    hasNewer!: boolean;
    nextTicket?: ChatTicketHeaderEntity | null;
    nextTicketPage!: number;
    nextTicketCached!: boolean;

    constructor({
                    data,
                    page,
                    pages,
                    limit,
                    totalRows,
                    date,
                    hasMore,
                    ticket,
                    previousTicket,
                    previousTicketCached,
                    hasNewer,
                    nextTicket,
                    nextTicketPage,
                    nextTicketCached,
                }: {
        data: TicketMessageEntity[];
        page: number;
        pages: number;
        totalRows: number;
        limit: number;
        date?: string;
        hasMore: boolean;
        ticket: ChatTicketHeaderEntity;
        previousTicket?: ChatTicketHeaderEntity | null;
        previousTicketCached: boolean;
        hasNewer?: boolean;
        nextTicket?: ChatTicketHeaderEntity | null;
        nextTicketPage?: number;
        nextTicketCached?: boolean;
    }) {
        super({data, page, pages, limit, totalRows, date, hasMore});
        Object.assign(this, {
            hasMore,
            ticket,
            previousTicket: previousTicket ?? null,
            previousTicketCached,
            hasNewer: hasNewer === true,
            nextTicket: nextTicket ?? null,
            nextTicketPage: nextTicketPage ?? 0,
            nextTicketCached: nextTicketCached === true,
        });
    }

    public static fromJson(json: Record<string, any>): ListPaginationChatMessagesEntity {
        return new ListPaginationChatMessagesEntity({
            page: Number(json['page'] ?? 0),
            pages: Number(json['pages'] ?? 0),
            totalRows: Number(json['totalRows'] ?? 0),
            limit: Number(json['limit'] ?? 0),
            date: json['date'],
            data: Array.isArray(json['data'])
                ? json['data'].map((item: Record<string, any>) => TicketMessageEntity.fromJson(item))
                : [],
            hasMore: json['hasMore'] === true,
            ticket: json['ticket']
                ? ChatTicketHeaderEntity.fromJson(json['ticket'])
                : new ChatTicketHeaderEntity(),
            previousTicket: json['previousTicket'] ? ChatTicketHeaderEntity.fromJson(json['previousTicket']) : null,
            previousTicketCached: json['previousTicketCached'] === true,
            hasNewer: json['hasNewer'] === true,
            nextTicket: json['nextTicket'] ? ChatTicketHeaderEntity.fromJson(json['nextTicket']) : null,
            nextTicketPage: Number(json['nextTicketPage'] ?? 0),
            nextTicketCached: json['nextTicketCached'] === true
        });
    }
}
